import { ToHTMLConverterMiddleware } from './base'
import { BLOCK_TYPE, INLINE_STYLE, ENTITY_TYPE } from 'draft-js-utils'
import { ANNOTATION_STYLE } from './../../../../DraftEditor/plugins/draft-js-annotations/index'

const { BOLD, CODE, ITALIC, STRIKETHROUGH, UNDERLINE } = INLINE_STYLE

export class StandardToHTMLConverterMiddleware extends ToHTMLConverterMiddleware {
  processStyle(content, style, block, context, nextCallback) {
    if (style.has(BOLD)) {
      content = `<b>${content}</b>`
    }
    if (style.has(UNDERLINE)) {
      content = `<u>${content}</u>`
    }
    if (style.has(ITALIC)) {
      content = `<i>${content}</i>`
    }
    if (style.has(STRIKETHROUGH)) {
      content = `<del>${content}</del>`
    }
    if (style.has(CODE)) {
      // If our block type is CODE then we are already wrapping the whole
      // block in a `<code>` so don't wrap inline code elements.
      const blockType = block.getType()
      content =
        blockType === BLOCK_TYPE.CODE ? content : `<code>${content}</code>`
    }
    return nextCallback(content, style, block, context)
  }

  processEntity(content, entity, nextCallback) {
    const entityType = entity.getType().toUpperCase()
    switch (entityType) {
      case ENTITY_TYPE.LINK: {
        const { url, target } = entity.data || { url: '#', target: undefined }
        content = `<a href="${url}"${
          target ? ` target="${target}"` : ''
        }>${content}</a>`
        break
      }
      case ANNOTATION_STYLE: {
        const { categoryId, itemId, childId } = entity.data
        content = `<mark data-annotation-category="${categoryId}" data-annotation-item="${itemId}" data-annotation-child="${
          childId ?? ''
        }">${content}</mark>`
        break
      }
      default:
        break
    }
    return nextCallback(content, entity)
  }
}
